import React from 'react';

import { GuestEntryDto } from 'legacy/tickets/types';

interface GuestHeaderProps {
  data: GuestEntryDto;
}

const GuestHeader: React.FC<GuestHeaderProps> = ({ data }) => (
  <>
    <div className="absolute top-0 left-0 h-24 w-full bg-linear-to-r from-[#D0CEFF] to-[#C4DDFF] z-10" />

    <div className="relative pt-11 mx-auto flex flex-col items-center justify-center z-20">
      <div className="w-28 h-28 object-cover rounded-full border-2 border-primary-300 overflow-hidden align-center justify-center flex bg-neutral-200">
        <img
          src={data?.user?.photoUrl ?? '/img/icons/account_circle.svg'}
          className="w-full"
        />
      </div>

      <div className="text-2xl mt-4 font-semibold">
        {data.type === 'ticket'
          ? `${data.user.firstName} ${data.user.lastName}`
          : data.name}
      </div>
    </div>
  </>
);

export default GuestHeader;
